import React, { useRef, useState } from 'react'
import { useApplicationContext } from '../../contexts/appContext'
import { ErrorDialog, LoadingDialog, Header, Layout } from '@verifier-user/verifier-cdr'
import { EastVenturesUnAuth } from './EastVenturesUnAuth'
import { EnergyUnAuth } from './EnergyUnAuth'
import { IncomeUnAuth } from './IncomeUnAuth'
import { BavUnAuth } from './BavUnAuth'

export const UnAuthorised = () => {
  const [error, setError] = useState(null)
  const [errorShown, setErrorShown] = useState(false)
  const [processing, setProcessing] = useState(false)
  const containerRef = useRef(null)
  const currentErrorRef = useRef(null)

  const { vendorSettings, vendorData, logout } = useApplicationContext()

  const components = {
    EastVenturesUnAuth,
    IncomeUnAuth,
    EnergyUnAuth,
    BavUnAuth
  }

  const getUnAuthComponent = () => {
    const UnAuthComponent = components[vendorData.unAuthComponent]
    return (
      <UnAuthComponent
        currentErrorRef={currentErrorRef}
        setProcessing={setProcessing}
        setError={setError}
        setErrorShown={setErrorShown}
      />
    )
  }

  return (
    <>
      <Header vendorSettings={vendorSettings} />
      <Layout
        vendorSettings={vendorSettings}
        isAuthenticated={() => {
          return false
        }}
        logout={logout}
      >
        <div ref={containerRef}>
          <LoadingDialog id={'fnf-un-authorised'} isOpen={processing} />

          <ErrorDialog
            id='unAuthDialog'
            error={error}
            open={errorShown}
            setOpen={setErrorShown}
            cancelHandler={currentErrorRef.current && currentErrorRef.current.cancelFunction}
            okTitle={
              currentErrorRef.current && currentErrorRef.current.okTitle ? currentErrorRef.current.okTitle : 'Ok'
            }
            cancelTitle={
              currentErrorRef.current && currentErrorRef.current.cancelTitle
                ? currentErrorRef.current.cancelTitle
                : 'Cancel'
            }
            retryHandler={currentErrorRef.current ? currentErrorRef.current.retryFunction : undefined}
          />

          {getUnAuthComponent()}
        </div>
      </Layout>
    </>
  )
}
